// extracted by mini-css-extract-plugin
export var settingsList = "_2s-0";
export var settingsRow = "_2s-1";
export var warningDot = "_2s-2";